import React from 'react';
import ScreeningComposerPage from 'components/ScreeningComposer/ScreeningComposerPage';
import { EXPORT_PROFILE } from 'components/ScreeningComposer/profiles';

const ExportScreeningComposer: React.FC = () => (
  <ScreeningComposerPage profile={EXPORT_PROFILE} />
);

export default ExportScreeningComposer;
